var map = {
	"./addthing.jpeg": 489,
	"./banner.jpeg": 513,
	"./concert.jpeg": 3,
	"./dj1-2.jpeg": 423,
	"./dj1.jpeg": 806,
	"./hand.jpeg": 927,
	"./movie.jpeg": 227,
	"./speech.jpeg": 31,
	"./tattoo.jpeg": 659,
	"./tea.jpeg": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;